import React from "react";
import { ArrowRight, ArrowDown } from "lucide-react";
import { hero } from "../mock";

const Hero = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="paper relative overflow-hidden">
      <div className="max-w-[1360px] mx-auto px-6 md:px-10 pt-16 pb-20 grid lg:grid-cols-2 gap-12 items-center">
        {/* Left */}
        <div className="reveal in-view">
          <div className="flex items-center gap-3 mb-8">
            <span className="block h-px w-10" style={{ background: "var(--gold)" }} />
            <span className="eyebrow">{hero.eyebrow}</span>
          </div>

          <h1 className="font-display leading-[0.92]" style={{ color: "var(--wine)" }}>
            <span className="block font-bold" style={{ fontSize: "clamp(3rem,8vw,7rem)" }}>
              {hero.titleTop}
            </span>
            <span className="block italic font-medium" style={{ fontSize: "clamp(3rem,8vw,7rem)" }}>
              {hero.titleItalic}
            </span>
          </h1>

          <p className="font-body mt-7 max-w-md text-[1.05rem] leading-relaxed" style={{ color: "var(--muted)" }}>
            {hero.subtitle}
          </p>

          <div className="flex flex-wrap items-center gap-7 mt-9">
            <button
              onClick={() => scrollTo("#the-edit")}
              className="btn-wine btn-3d flex items-center gap-3 rounded-full px-8 py-4 font-mono2"
              style={{ fontSize: "0.7rem", letterSpacing: "0.16em" }}
            >
              SHOP THE COLLECTION <ArrowRight size={15} />
            </button>
            <button
              onClick={() => scrollTo("#our-story")}
              className="link-underline flex items-center gap-2 font-mono2"
              style={{ fontSize: "0.7rem", letterSpacing: "0.16em", color: "var(--wine)" }}
            >
              DISCOVER NAARI <ArrowDown size={14} />
            </button>
          </div>

          <div className="mt-14 pt-6" style={{ borderTop: "1px solid rgba(89,26,32,0.15)" }}>
            <div className="flex items-center gap-6 flex-wrap">
              {hero.tags.map((t, i) => (
                <div key={t} className="flex items-center gap-6">
                  <span className="eyebrow" style={{ color: "var(--muted)" }}>{t}</span>
                  {i < hero.tags.length - 1 && (
                    <span className="w-1.5 h-1.5 rounded-full" style={{ background: "var(--gold)" }} />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right - images */}
        <div className="relative h-[520px] md:h-[620px]">
          {/* Offset shadow block */}
          <div
            className="absolute rounded-sm"
            style={{ top: 24, left: 40, right: 60, bottom: -12, background: "var(--tan)", opacity: 0.6 }}
          />
          <div className="absolute overflow-hidden rounded-sm" style={{ top: 0, left: 20, width: "72%", height: "88%" }}>
            <img src={hero.imageMain} alt="Woman in dusty rose saree" className="w-full h-full object-cover" />
          </div>
          <div
            className="absolute overflow-hidden rounded-sm shadow-xl"
            style={{ bottom: 0, right: 0, width: "46%", height: "42%", border: "6px solid var(--cream)" }}
          >
            <img src={hero.imageSecondary} alt="Woman in ivory saree" className="w-full h-full object-cover" />
          </div>

          {/* softly made badge */}
          <div
            className="absolute flex flex-col items-center justify-center rounded-full"
            style={{
              top: -18, right: 8, width: 104, height: 104,
              background: "var(--cream-3)", border: "1px solid var(--gold)",
            }}
          >
            <span className="font-display italic" style={{ color: "var(--wine)", fontSize: "1.05rem", lineHeight: 1 }}>
              {hero.badge[0]}
            </span>
            <span className="font-display italic" style={{ color: "var(--wine)", fontSize: "1.05rem", lineHeight: 1.2 }}>
              {hero.badge[1]}
            </span>
          </div>
        </div>
      </div>

      <div className="max-w-[1360px] mx-auto px-6 md:px-10 pb-10">
        <span className="eyebrow" style={{ color: "var(--muted)" }}>{hero.counter}</span>
      </div>
    </section>
  );
};

export default Hero;
